import { transition } from '@helpers/animate';
import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { SitePaddingMobile } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h2 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --tint: 0.5;

  position: relative;
  color: ${brand.white};
  overflow: hidden;

  ${SectionWrapperStyles.SiteWide} {
    @media ${until(Device.Tablet)} {
      padding: 0;
    }
  }
`;
const List = styled.div `
  display: grid;
`;
const Item = styled.div `
  ${transition('opacity')};

  grid-column: 1;
  grid-row: 1;

  &[data-active='false'] {
    opacity: 0;
    pointer-events: none;
  }

  &[data-active='true'] {
    opacity: 1;
  }
`;
const Inner = styled.div `
  display: none;

  @media ${from(Device.Tablet)} {
    height: 100%;
    min-height: calc(90vh - var(--headerHeight));
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
const TitleArea = styled.div ``;
const Title = styled.h1 `
  ${h2};
  color: ${brand.white};

  @media ${from(Device.TabletSmall)} {
    max-width: 20ch;
  }
`;
const MobileTitle = styled(Title) `
  position: absolute;
  bottom: 48px;
  margin: 0;
  padding-left: ${SitePaddingMobile}px;
  padding-right: ${SitePaddingMobile}px;

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const ContentAreaMobile = styled.div `
  padding: calc(${SitePaddingMobile}*3px) ${SitePaddingMobile}px ${SitePaddingMobile}px;

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const Content = styled.div `
  ${contentStyles};

  @media ${from(Device.TabletSmall)} {
    max-width: 60ch;
  }
`;
const CtaWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 30px;

  @media ${until(Device.TabletSmall)} {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const CtaSpacer = styled.span `
  ${fonts.avenir.regular};
  font-size: 20px;
  line-height: 30px;
  margin: 0;
  display: inline-block;
  color: ${brand.white};
`;
const ImageWrapper = styled.div `
  position: relative;
  max-height: 562px;
  height: calc(80vh - var(--headerHeight));
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${from(Device.Tablet)} {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    max-height: calc(90vh - var(--headerHeight));
  }
`;
const DesktopMedia = styled.div `
  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const MobileMedia = styled.div `
  height: 100%;
  width: 100%;

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const BottomWrapper = styled.div `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: var(--indicatorSize);
  width: 100%;
`;
const Overlay = styled.div `
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 35%;
  left: 0;
  background: linear-gradient(0, rgba(0, 0, 0, var(--tint)) 0%, rgba(255, 255, 255, 0) 50%);

  @media ${from(Device.Tablet)} {
    position: relative;
    bottom: auto;
    left: auto;
    height: 100%;
    background: linear-gradient(90deg, rgba(0, 0, 0, var(--tint)) 0%, rgba(255, 255, 255, 0) 50%);
  }
`;
const HomePageHeroStyles = {
    BottomWrapper,
    Container,
    Content,
    ContentAreaMobile,
    CtaSpacer,
    CtaWrapper,
    DesktopMedia,
    Image,
    ImageWrapper,
    Inner,
    Item,
    List,
    MobileMedia,
    MobileTitle,
    Overlay,
    Title,
    TitleArea,
};
export default HomePageHeroStyles;
